import React, { useState } from 'react';
import { Check } from 'lucide-react';
interface PriceOption {
  id: string;
  currency: string;
  symbol: string;
  price: string;
  label: string;
  url: string;
}
const priceOptions: PriceOption[] = [{
  id: 'ars',
  currency: 'ARS',
  symbol: '$',
  price: '19.990',
  label: 'Pesos Argentinos',
  url: 'https://checkout.equilibriodigital.shop/cart/47588015079614:1'
}];
interface PriceCTAProps {
  ctaLabel?: string;
  align?: 'center' | 'left';
}
export function PriceCTA({
  ctaLabel = 'QUIERO MI MENTE RESUELTA AHORA',
  align = 'center'
}: PriceCTAProps) {
  const [selectedId, setSelectedId] = useState(priceOptions[0].id);
  const selected = priceOptions.find(o => o.id === selectedId) ?? priceOptions[0];
  const handlePurchase = () => {
    window.open(selected.url, '_blank', 'noopener,noreferrer');
  };
  return <div className={`w-full max-w-lg ${align === 'center' ? 'mx-auto' : ''} flex flex-col gap-4`} data-id="element-144">
      <div className="flex flex-col gap-3" data-id="element-145">
        {priceOptions.map(opt => {
        const isSelected = opt.id === selectedId;
        return <button key={opt.id} type="button" onClick={() => setSelectedId(opt.id)} aria-pressed={isSelected} className={`group relative flex items-center justify-between gap-4 px-5 py-4 border transition-all duration-300 text-left ${isSelected ? 'border-terracotta bg-terracotta/10' : 'border-white/15 bg-white/[0.02] hover:border-white/30'}`} data-id="element-146">
              <div className="flex items-center gap-4" data-id="element-147">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors ${isSelected ? 'border-terracotta bg-terracotta' : 'border-white/30'}`} data-id="element-148">
                  {isSelected && <Check size={12} className="text-cream" strokeWidth={3} data-id="element-149" />}
                </div>
                <div data-id="element-150">
                  <div className="text-xs uppercase tracking-widest text-cream/50 mb-0.5" data-id="element-151">
                    {opt.label}
                  </div>
                  <div className="font-serif text-2xl md:text-3xl text-cream" data-id="element-152">
                    {opt.symbol}
                    {opt.price}{' '}
                    <span className="text-sm uppercase tracking-widest text-cream/50 font-sans align-middle" data-id="element-153">
                      {opt.currency}
                    </span>
                  </div>
                </div>
              </div>
              <div className="text-xs text-cream/40 uppercase tracking-widest hidden sm:block" data-id="element-154">
                Pago único
              </div>
            </button>;
      })}
      </div>

      <button onClick={handlePurchase} className="group relative inline-flex items-center justify-center bg-terracotta hover:bg-terracotta-dark text-cream font-medium px-8 py-5 text-lg sm:text-xl transition-all duration-300 ease-out w-full" data-id="element-155">
        <span className="relative z-10 flex items-center gap-3" data-id="element-156">
          <span className="text-2xl" data-id="element-157">🛑</span> {ctaLabel}
        </span>
      </button>

      <p className="text-xs text-cream/40 text-center" data-id="element-158">
        Redireccionado a un checkout seguro · Acceso inmediato tras el pago
      </p>
    </div>;
}